module.exports = __webpack_public_path__ + "b4129cce214534ae06d68fa44314caa4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-31.png
// module id = 2297
// module chunks = 0